export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDij_3KDNkqaSwxXC9uokscYk4OK2VjRZ4",
    authDomain: "trans-3934f.firebaseapp.com",
    projectId: "trans-3934f",
    storageBucket: "trans-3934f.firebasestorage.app",
    messagingSenderId: "651096224048",
    appId: "1:651096224048:web:c43cd3fed70d6397ec18f5",
    measurementId: "G-16DR7FFS0J"
  },
  //baseUrl: 'http://localhost:3002/api',
   baseUrl: 'https://dev-api.transtech.sa/api',
};
